
// If there is a nav
if ( biro_pnh !== null ) {

  // DOM loaded
  document.addEventListener('DOMContentLoaded', function () {

    // Compact?
    biro_pnh_set_compact();

  }, false);

  // Set a debounce timer variable
  let debounce_timer = true;

  // When the window scrolls
  window.onscroll = function () {

    // If there's a debounce time already in operation
    if ( debounce_timer ) {

      // Clear the timeout
      window.clearTimeout( debounce_timer );

      // Set a function to run after a timeout
      debounce_timer = window.setTimeout( function () {

        // Compact?
        biro_pnh_set_compact();

        // Loop through the links
        document.querySelectorAll( '#page-nav-horizontal a' ).forEach( function ( element ) {

          // Remove any current classes
          element.classList.remove( 'current' );

        } );

        // Create a variable for last heading tested
        let last_heading = false;

        // Loop through the headings on the page
        document.querySelectorAll( '.main > h2' ).forEach( function ( heading ) {

          // If the top of the heading heading is more than halfway up the page
          if ( heading.getBoundingClientRect().top < ( window.innerHeight / 2 ) ) {

            // Set the last_heading tested to this one
            last_heading = heading;

          }

        } );

        // If there's a heading (there might not be when scrolling to the top)
        if ( last_heading ) {

          // Add the 'current' class to the matching list item link
          document.querySelector( '#page-nav-horizontal li a[ href="#' + last_heading.getAttribute( 'id' ) + '" ]' ).classList.add( 'current' );

        } else {

          // Default to first
          document.querySelector( '#page-nav-horizontal li:first-child a' ).classList.add( 'current' );

        }

      }, 100 );
    }
  };

  // Add a click event listener on the toggle
  biro_pnh_toggle.addEventListener( 'click', function ( event ) {

    // If the menu isn't expanded
    if ( biro_pnh_toggle.getAttribute( 'aria-expanded' ) === 'false' ) {

      // Show it
      biro_pnh_list_show();

      // Otherwise the menu is expanded
    } else {

      // Hide it
      biro_pnh_list_hide();

    }

    // Remove focus from toggle
    biro_pnh_toggle.blur();

  } );

}


/**
 * Set section nav to compact state
 *
 * @return void
 */
function biro_pnh_set_compact() {

  // Has the content gone under the sticky nav block?
  // Use offset to avoid loop - not quite working?
  let offset = ( biro_pnh.classList.contains( 'compact' ) ? 0 : 150 );
  if (
    ( biro_pnh.getBoundingClientRect().bottom - offset ) >
    biro_pnh_next_block.getBoundingClientRect().top
  ) {

    // Mark the nav as compact
    biro_pnh.classList.add( 'compact' );

  } else {

    // Mark the nav as not compact
    biro_pnh.classList.remove( 'compact' );

  }

}


/**
 * Show section nav list
 *
 * @return void
 */
function biro_pnh_list_show() {

  // Define the max height as the window height
  navMaxHeight = window.innerHeight;

  // Remove the height of the toggle
  navMaxHeight -= biro_pnh_toggle.getBoundingClientRect().height;

  // If the admin bar is there
  if ( adminBar = document.querySelector( '#wpadminbar' ) ) {

    // Remove the height of the admin bar
    navMaxHeight -= adminBar.getBoundingClientRect().height;

  }

  // Set the max-height property
  // +1 is for a border somewhere
  biro_pnh_list.style.maxHeight = ( navMaxHeight + 1 ) + 'px';

  // Display it
  biro_pnh_list.style.display = 'block';

  // Flag that the menu is expanded
  biro_pnh_toggle.setAttribute( 'aria-expanded', 'true' );
  biro_pnh.classList.add( 'is-expanded' );

}

/**
 * Hide section nav list
 *
 * @return void
 */
function biro_pnh_list_hide() {

  // Hide the menu
  biro_pnh_list.style.display = 'none';

  // Flag that the menu is not expanded
  biro_pnh_toggle.setAttribute( 'aria-expanded', 'false' );
  biro_pnh.classList.remove( 'is-expanded' );

}